const MATTER_TYPE_MAP = {
  FAMILY_LAW: 'Family Law',
  TRUSTS_AND_ESTATES: 'Trusts & Estates',
} as const;

type MatterType = keyof typeof MATTER_TYPE_MAP;

export function getMatterTypeName(enumName: MatterType) {
  return MATTER_TYPE_MAP[enumName];
}
